module.exports = __webpack_public_path__ + "static/media/vp_skip.e7284f7f.svg";